// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"140":"548d8655","725":"09cf2a99"}[chunkId] + ".chunk.js";
};